/**
 * Created with IntelliJ IDEA.
 * User: omerh
 * Date: 5/7/13
 * Time: 2:14 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var Template = require("templates/top-level-menu/topLevelMenuItem.tmpl");
    var _ = require("underscore");

    var TopLevelMenuItemView = Marionette.ItemView.extend({
        template: Template,
        tagName: "div",
        className: "top-level-menu-item",
        ui: {
            title: ".top-level-menu-item-title",
            indicator: ".top-level-menu-item-indicator"
        },
        events: {
            "click": "_onClicked"
        },
        modelEvents: {
            "change:enabled": "_updateEnabledClass",
            "change:title": "_updateTitle",
            "change:indicatorClass": "_updateIndicatorClass",
            "change:indicatorText": "_updateIndicatorText"
        },
        onRender: function() {
            this.$el.addClass(this.model.get("className"));
            this._updateEnabledClass();
            this._updateIndicatorClass();
        },
        _refreshView: function () {
            this._updateEnabledClass();
        },
        _updateTitle: function() {
            this.ui.title.text(this.model.get("title"));
        },
        _updateEnabledClass: function() {
            this.$el.toggleClass("enabled", this._isEnabled());
        },
        _updateIndicatorText: function() {
            var indicatorText = this.model.get("indicatorText");
            if (_.isString(indicatorText)){
                this.ui.indicator.text(indicatorText);
            }
        },
        _updateIndicatorClass: function() {
            var indicatorClass = this.model.get("indicatorClass");
            if (indicatorClass) {
                this.ui.indicator.removeClass("red");
                this.ui.indicator.removeClass("green");
                this.ui.indicator.addClass(this.model.get("indicatorClass"));
            }
        },
        _onClicked: function () {
            if(!this._isEnabled()) {
                return;
            }

            var callback = this.model.get("callback");
            if (_.isFunction(callback)) {
                var context = this.model.get("context") ? this.model.get("context") : this;
                _.defer(function (callback, context) {
                    callback.call(context);
                }, callback, context);
            }


        },
        _isEnabled: function() {
            return this.model.get("enabled");
        }
    });
    return TopLevelMenuItemView;
});
